export function doNothing() {
    return doesNothing;
}
function doesNothing() {
}
